<template>
    <div>
        <table class="authorization-table" border="0" cellspacing='0' cellpadding='0'>
            <thead>
                <tr>
                    <th style='width:32px;'>选择</th>
                    <th style='width:120px;'>授权名称</th>
                    <th style='width:64px;'>到期时间</th>
                    <th style='width:115px;'>
                        <h5>价格<template v-if="orderLimit != -1">(单位：{{unit}})</template></h5>
                    </th>
                    <th style='width:45px;'>备注</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item,index) in tableData" :key='index' @click="choose(item,index)">
                    <td style="text-align: center;">
                        <div class="select" :class="{active: item._selected,disabled: item._disabled || item._exist,exist: item._exist}"></div>
                    </td>
                    <td>
                        {{item.productName}}
                    </td>
                    <td>
                        {{item.right_end_date}}
                    </td>
                    <td>
                        <span class="price"
                            :class="{major_active:item._ismajor == 0 || item._ismajor == null || item.price == item.majorprice}">
                            {{(item._exist ? '' : '+')+(isMonth ? item.monthprice : (isQuarter ? price(item.quarterPrice) : price(item.price)))}}
                            </span>
                            <i class="tips" v-if='item.id == 291'>
                                <div class="tips_content">
                                    欧交所个人价格只针对中国境内用户有效
                                </div>
                            </i>
                        <span v-show="item.price != item.majorprice && (!(isMonth && !item.isMainAuth))" class="price"
                            :class="{major_active:item._ismajor == 1 || item._ismajor == null}">/+{{isQuarter ? price(item.quartermajorprice) : price(item.majorprice)}}(公司)</span>
                    </td>
                    <td class="pop">
                        <span v-show='item.productintro'>交易品种</span>
                        <div v-show='item.productintro' @click.stop='_=>{}' class="pop_wraper" v-html="item.productintro"></div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
    // @ is an alias to /src
    import wh from '@/assets/js/wh.js'
    export default {
        name: 'authtable',
        model: {
            prop: 'authPrice',
            event: 'change'
        },
        props: {
            authData: {
                type: Array,
                default: []
            },
            authPrice: {
                type: Number,
                default: 0
            },
            orderLimit: {
                type: Number,
                default: -1
            }
        },
        data: () => ({
            tableData: [],
            priceMode: ''
        }),
        methods: {
            async click(item, index) {
                if(item._disabled || item._exist) return //已禁用的不做任何操作
                if (item._selected == false) {
                    // if (item.price != item.majorprice && item._ismajor == null) {
                    //     var option = await new Promise(resolve => {
                    //         this.$market.purchaserSelect({
                    //             list: [{
                    //                     text: '本人确认，本人符合非专业用户资格'
                    //                 },
                    //                 {
                    //                     text: '本人确认，本人符合专业用户资格'
                    //                 }
                    //             ],
                    //             confirmCall(val) {
                    //                 resolve(val)
                    //             }
                    //         })
                    //     })
                    //     item._ismajor = option
                    //     if (item.productlink && item.productlink.indexOf('EUREX') < 0) {
                    //         this.tableData.forEach(v=>{
                    //             if (v.productlink && v.productlink.indexOf('EUREX') < 0 && v.price != v.majorprice) {
                    //                 v._ismajor = option
                    //             }
                    //         })
                    //     }
                    // }
                    
                    item._selected = true
                    
                    
                } else {
                    item._selected = false
                    // var unEUREX = this.tableData.filter(v=>v.productlink && v.productlink.indexOf('EUREX') < 0 && v.price != v.majorprice)
                    // if (item.productlink && item.productlink.indexOf('EUREX') < 0 && !unEUREX.some(v=>v._selected == true)) {
                    //     unEUREX.forEach(v=> {
                    //         v._ismajor = null
                    //     })
                    // } else if (item.productlink && item.productlink.indexOf('EUREX') >= 0) {
                    //     item._ismajor = null
                    // }
                }
                this.tableData.forEach(v=>{
                    if (v._id != item._id && v.isMutex == item.isMutex && v.isMutex != 0) {
                        if (item._selected) {
                            v._disabled = !v._disabled
                        } else {
                            v._disabled = false
                        }
                    }
                })
                this.$nextTick(() => {
                    this.$emit('change',this.totalPrice)
                })
            },
            cancelEach (call) {
                //取消所有选中或者禁用的状态，暴露于外部使用
                this.tableData.forEach(v=>{
                    if(call && call(v)) {
                        if(v._exist) return
                        this.$set(v,'_selected',false)
                        this.$set(v,'_ismajor',null)
                    }
                })
                this.$nextTick(() => {
                    this.$emit('change',this.totalPrice)
                })
            },
            setDisableEach (call) {
                this.tableData.forEach(v=>{
                    if(v._exist) return
                    this.$set(v,'_disabled',call && call(v))
                })
            },
            getSelections () {
                let selections = []
                this.tableData.forEach(v=>{
                    if (v._selected) {
                        selections.push(v)
                    }
                })
                return selections
            },
            choose (item,index) {
                this.$emit('choose',this.click, item, index)
            },
            selectItemByMemory (item) {//根据外部组件浅拷贝的缓存数据，选中当前组件中的项
                let target = this.tableData.find(v=>v.id == item.id)
                this.click(target)
                
            },
            setMajorAll () {
                this.tableData.forEach(v=>{
                    if (!v.productlink || (v.productlink.indexOf('EUREX') < 0 && v.productName.indexOf('香港') < 0)) {
                        v._ismajor = 1
                    }
                })
                this.$nextTick(() => {
                    this.$emit('change',this.totalPrice)
                })
            },
            setUnMajorAll () {
                this.tableData.forEach(v=>{
                    if (!v.productlink || (v.productlink.indexOf('EUREX') < 0 && v.productName.indexOf('香港') < 0)) {
                        v._ismajor = 0
                    }
                })
                this.$nextTick(() => {
                    this.$emit('change',this.totalPrice)
                })
            },
            setJg () {
                this.tableData.forEach(v=>{
                    if (v.productlink && (v.productlink.indexOf('EUREX') >= 0 || v.productName.indexOf('香港') >= 0)) {
                        v._ismajor = 1
                    }
                })
                this.$nextTick(() => {
                    this.$emit('change',this.totalPrice)
                })
            },
            setNotJg () {
                this.tableData.forEach(v=>{
                    if (v.productlink && (v.productlink.indexOf('EUREX') >= 0 || v.productName.indexOf('香港') >= 0)) {
                        v._ismajor = 0
                    }
                })
                this.$nextTick(() => {
                    this.$emit('change',this.totalPrice)
                })
            },
            setPriceByItem (item) {
                let target = this.tableData.find(v => v.id == item.id)
                this.$set(target, 'quarterPrice', item.quarterPrice)
                this.$set(target, 'quartermajorprice', item.quartermajorprice)
                
                this.$nextTick(() => {
                    this.$emit('change',this.totalPrice)
                })
            },
            price (x) {
                if (!x) return 0
                return parseInt(x)
            }
        },
        computed: {
            totalPrice() {
                var price = 0;
                this.tableData.forEach((v, i) => {
                    if (v._selected) {
                        if (v._ismajor == 0) {
                            price += this.price(this.isQuarter ? v.quarterPrice : v.price)
                        } else if (v._ismajor == 1) {
                            price += this.price(this.isQuarter ?  v.quartermajorprice : v.majorprice)
                        } else {
                            price += this.price(this.isQuarter ? v.quarterPrice : v.price)
                        }
                    }
                })
                return price;
            },
            unit () {
                if (this.isMonth) {
                    return '元/账号/月'
                } else if (this.isQuarter) {
                    return '元/账号/季'
                } else {
                    return '元/账号/年'
                }
            },
            hasOut () {
                let flag = false
                this.tableData.forEach(v=>{
                    if ((v.grouptype == 1 || v.grouptype == 2 || v.grouptype == 3 || v.grouptype == 4) && v._selected) {
                        flag = true
                    }
                })
                return flag
            },
            selectIds () {
                return this.tableData.filter(v=>v._selected).map(v=>v.id).join(',')
            },
            selectEUREX () {
                return this.tableData.filter(v=>v._selected && v.productlink && (v.productlink.indexOf('EUREX') >= 0 || v.productName.indexOf('香港') >= 0) && v.price != v.majorprice)
            },
            selectOut () {
                return this.tableData.filter(v=>v._selected && v.productlink && v.productlink.indexOf('EUREX') < 0 && v.productName.indexOf('香港') < 0 && v.price != v.majorprice)
            },
            isMonth () {
                return this.orderLimit < 1
            },
            isQuarter () {
                return this.orderLimit == 2
            },
            hasSelectedHistory () {
                return this.tableData.some(v=> (v.grouptype == 7 || v.grouptype == 8) && v._selected)
            }
        },
        watch: {
            authData: {
                handler(val) {
                    if (val.length <= 0) return
                    this.tableData = val.map(v => {
                        let obj = {
                            ...v,
                            _id: wh.randomId()
                        }
                        //如果_ismajor为-1，视为0，后台定的具体涉及改动联系后台
                        if(obj._ismajor == -1) obj._ismajor = 0
                        if (!obj._ismajor && obj._ismajor != 0) {
                            obj._ismajor = null
                        }
                        return obj
                    })
                    this.$nextTick(() => {
                        this.$emit('change',this.totalPrice)
                    })
                },
                immediate: true,
                deep: true
            },
            totalPrice (val) {
                this.$emit('change',this.totalPrice)
            }
        },
        mounted() {
        }
    }
</script>
<style scoped>
    .authorization-table {
        border: 1px solid rgb(186, 190, 193);
        border-collapse: collapse;
        width: 100%;
        text-align: left;
        font-size: 12px;
        color: #525252;
        background: white;
    }
    
    .authorization-table tr:hover {
        background-color: rgb(233, 241, 253);
    }
    .authorization-table th {
        background: rgb(231, 235, 238);
        color: rgb(101, 105, 108);
        font-size: 13px;
        height: 24px;
        padding: 2px;
        text-align: center;
        border: 0;
    }
    .authorization-table h5,
    .authorization-list table p {
        margin: 0;
        padding: 0;
    }
    .authorization-table th h5 {
        font-size: 13px;
    }
    .authorization-table th p {
        font-size: 12px;
        font-weight: normal;
    }
    .authorization-table td {
        text-align: left;
        border-bottom: 1px solid rgb(231, 235, 238);
        border-right: 1px solid rgb(231, 235, 238);
        height: 24px;
        padding: 2px 5px;
    }
    .authorization-table td i.tips{
        display: inline-block;
        width: 12px;
        height: 12px;
        background: url(../../../assets/image/zhuyi.png) no-repeat center;
        position: relative;
        margin-left: 3px;
    }
    .authorization-table td i.tips .tips_content {
        display: none;
        position: absolute;
        top: 15px;
        left: -46px;
        font-style: normal;
        width: 200px;
        text-align: left;
        border: 1px dashed #aba1ce;
        background: #fffdec;
        z-index: 10;
        padding: 10px 1px 10px 10px;
    }
    .authorization-table td i.tips:hover .tips_content {
        display: block;
    }
    .authorization-table tr td:last-child {
        border-right: 0;
    }
    .authorization-table tr:last-child  td{
        border-bottom: 0;
    }
    .authorization-table td .price {
        font-size: 12px;
        color: rgb(189, 189, 189);
    }
    .authorization-table td .price.major_active {
        font-weight: normal;
        font-size: 12px;
        color: #78363A;
    }
    .authorization-table td.pop {
        color: #1261D2;
        position: relative;
    }
    .authorization-table td .pop_wraper {
        display: none;
        width: 427px !important;
        text-align: left !important;
        padding: 15px 15px 15px 20px;
        border: 1px dashed #aba1ce;
        background: #fffdec;
        position: absolute;
        left: -410px;
        z-index: 10;
        color: #525252;
        /* display: none; */
        top: 35px;
    }
    .authorization-table td.pop:hover .pop_wraper {
        display: block;
    }
    .authorization-table td .pop_wraper::before {
        content: '';
        position: absolute;
        right: 6px;
        top: -10px;
        border-bottom: 10px solid #73a3e8;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
    }
    .authorization-table td .select {
        width: 13px;
        height: 13px;
        display: inline-block;
        border-radius: 100%;
        border: 1px solid rgb(173, 173, 165);
    }
    .authorization-table td .select.active {
        background: rgb(242, 153, 1) url(../../../assets/image/dui-bai.png) no-repeat center;
        border-color: rgb(242, 153, 1);
    }
    
    .authorization-table td .select.disabled {
        background: rgb(228, 228, 228);
    }
    .authorization-table td .exist.disabled {
        background: rgb(255, 208, 129) url(../../../assets/image/dui-bai.png) no-repeat center;
        border-color: rgb(255, 208, 129);
    }
</style>>